<template>
    <div class="admin-page">
        <el-container>
            <el-header>
                <lHeader></lHeader>
            </el-header>
            <el-container>
                <el-aside width="200px">
                    <lMenu></lMenu>
                </el-aside>
                <el-container>
                    <el-main>
                        <keep-alive >
                            <router-view :key="key" />
                        </keep-alive>
                    </el-main>
                </el-container>
                </el-container>
            </el-container>
    </div>
</template>
<script>
import lHeader from './components/layout/header.vue'
import lMenu from './components/layout/menu.vue'
export default {
    components:{
        lHeader , lMenu
    },
    computed: {
        key() {
          return this.$route.path
        }
    },
    data(){
        return{
           
        }
    }
}
</script>
<style lang="less" >
.admin-page{
    width: 100vw;
    height: 100vh;
    background-image: linear-gradient(to right, rgba(67,116,248) 0%, rgb(121,215,211) 100%);
    display: flex;
    justify-content: center;
    align-items: center;
    .el-header, .el-footer {
        text-align: center;
        line-height: 60px;
    }
  
    .el-aside {
        background-color: rgb(14,16,43);
        text-align: center;
        height: calc(100vh - 60px);
    }
  
  .el-main {
    background-color: #E9EEF3;
    color: #333;
  }
  
  body > .el-container {
    margin-bottom: 40px;
  }
  
  .el-container:nth-child(5) .el-aside,
  .el-container:nth-child(6) .el-aside {
    line-height: 260px;
  }
  
  .el-container:nth-child(7) .el-aside {
    line-height: 320px;
  }
}
</style>